import { makeStyles, Theme } from '@material-ui/core/styles'
import { createStyles } from '@material-ui/core'

/** Seller actions only; layout/typography come from listed-item `info-component.styles`. */
export const useOwnItemInfoActionsStyles = makeStyles((theme: Theme) =>
  createStyles({
    actionsSection: {
      marginTop: theme.spacing(0.75),
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
    },
    actionBtn: {
      textTransform: 'none',
    },
    noDescription: {
      fontStyle: 'italic',
      color: theme.palette.text.secondary,
    },
    loadingActions: {
      marginTop: theme.spacing(1),
    },
  })
)
